import { useSuspenseQuery } from '@apollo/client/react';
import { Text } from '@chakra-ui/react';

import { DocumentUploadsTable } from './document-uploads-table';

import { GET_UPLOADS_FOR_DOCUMENT } from '#src/graphql/queries/document-uploads';

function DocumentFilesBlockLoaded({
  documentId,
  apiHost,
}: {
  documentId: string;
  apiHost: string;
}) {
  const { data } = useSuspenseQuery(GET_UPLOADS_FOR_DOCUMENT, {
    variables: { documentId, limit: 200 },
    fetchPolicy: 'cache-first',
  });

  const rows = data?.uploadsForDocument ?? [];

  return (
    <DocumentUploadsTable
      rows={rows}
      apiHost={apiHost}
      emptyMessage="No files linked to this document yet. Upload from the Files page, paste images into the editor, or use Upload file… there."
    />
  );
}

export function DocumentFilesBlock({
  documentId,
  apiHost,
}: {
  documentId: string | undefined;
  apiHost: string;
}) {
  if (!documentId) {
    return (
      <Text color="fg.muted" fontSize="sm">
        Save the document to list uploads linked to it.
      </Text>
    );
  }

  return <DocumentFilesBlockLoaded documentId={documentId} apiHost={apiHost} />;
}
